var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5059 2.74414C18.9299 2.74414 18.3554 2.96614 17.9159 3.40714L14.2139 7.10314L5.22291 5.50414L3.10191 7.62514L11.0219 10.2996L6.46041 14.8821L4.68741 14.5101L2.56641 16.6311L6.29841 18.2001L7.86891 21.9321L9.99291 19.8111L9.62991 18.0531L14.2124 13.4706L16.9049 21.3756L19.0259 19.2546L17.4344 10.2501L21.0959 6.58864C21.3053 6.37989 21.4715 6.13185 21.5849 5.85875C21.6983 5.58565 21.7567 5.29285 21.7567 4.99714C21.7567 4.70143 21.6983 4.40863 21.5849 4.13553C21.4715 3.86243 21.3053 3.61439 21.0959 3.40564C20.8874 3.19638 20.6396 3.03036 20.3667 2.9171C20.0939 2.80384 19.8013 2.74407 19.5059 2.74414Z",
    stroke: "#2D3036",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.bdc938a13169f35717afaa5a97b5bfc4.svg";
export { ForwardRef as ReactComponent };